<template>
  <a-spin :spinning="confirmLoading">
    <a-form-model :model="model" layout="inline" ref="form" style="margin-left:25px">
      <a-row>
        <a-col :span="6">
          <a-form-model-item label="巡检时间">{{ model.recordTime }}</a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="设备总数">{{ model.recordDevCount }}&nbsp;&nbsp;台套</a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="巡检结果">{{ model.recordRes_dictText }}</a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="复核人">{{ model.reviewPerson_dictText }}</a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-card :bordered="false" style="margin-top: 14px" title="智能识别">
      <div class="no-data"><a-icon type="frown-o" />暂无数据</div>
    </a-card>
    <a-card :bordered="false" style="margin-top: 14px" title="告警">
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :scroll="{ x: 1600 }"
        @change="handleTableChange"
        bordered
        class="j-table-force-wrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="alertName" slot-scope="devId_dictText, item">{{ item.devId_dictText || '工艺告警' }}</span>
        <span slot="levelSlot" slot-scope="alertLevel, item">
          <span v-if="item.alertLevel == 1">
            <a-tag color="#ff4d4f">紧急告警</a-tag>
          </span>
          <span v-else-if="item.alertLevel == 2">
            <a-tag color="#faad14">严重告警</a-tag>
          </span>
          <span v-else>
            <a-tag color="#52c41a">一般告警</a-tag>
          </span>
        </span>
        <span slot="recoverySlot" slot-scope="isRecovery, item">
          <a-tag color="#ff4d4f" v-if="item.isRecovery == 0">未恢复</a-tag>
          <a-tag color="#52c41a" v-else>已恢复</a-tag>
        </span>

        <span slot="isAcknowledgementSlot" slot-scope="isAcknowledgement, item">
          <a-tag color="gray" v-if="item.isAcknowledgement == 0">未确认</a-tag>
          <a-tag color="#52c41a" v-else>已确认</a-tag>
        </span>
      </a-table>
    </a-card>
    <a-card :bordered="false" style="margin-top: 14px" title="工艺重点测点">
      <a-descriptions
        :key="devProcess"
        :title="`${devProcess}`"
        v-for="(itemData, devProcess) in dataSource1"
        bordered
        size="small"
        v-if="dataSource1 != null"
      >
        <a-descriptions-item
          :key="index"
          :label="`${item.pointName} ${item.dataUnit != null && item.dataUnit != '' ? '(' + item.dataUnit + ')' : ''}`"
          v-for="(item, index) in itemData"
          ><div :style="getDescItemStyle(item, index)">{{ item.value }}</div></a-descriptions-item
        >
      </a-descriptions>
      <div class="no-data" v-else><a-icon type="frown-o" />暂无数据</div>
    </a-card>
    <a-divider />
    <a-row>
      <a-col :span="24">
        <div class="card-head-title">
          数据断面：
          <a
            @click="handleToPointsUrl(model.recordTime)"
            style="fontSize: 16px;color: #108ee9;fontWeight: bold;margin-left: 20px"
            >{{ model.recordTime }}</a
          >
        </div>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>
import '@/assets/less/TableExpand.less'
import moment from 'moment'
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { validatenull, validatenotnull } from '@/utils/validate'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'EvntProcessInfoForm',
  mixins: [JeecgListMixin, mixinDevice],
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
    return {
      disableMixinCreated: true,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      confirmLoading: false,
      url: {
        list: '/alert/iotAlert/getIotAlertList',
        getIotModelPoints: '/monitor/data/getImportantPointsSectionData'
      },
      // 表头
      columns: [
        {
          title: '告警名称',
          align: 'center',
          dataIndex: 'devId_dictText',
          scopedSlots: { customRender: 'alertName' }
        },
        {
          title: '告警时间',
          align: 'center',
          dataIndex: 'alertTime',
          customRender: forceNowrap,
          sorter: true
        },
        {
          title: '告警信息',
          align: 'center',
          dataIndex: 'summary',
          width: '300px',
          align: 'left'
        },
        {
          title: '是否确认',
          align: 'center',
          dataIndex: 'isAcknowledgement',
          scopedSlots: { customRender: 'isAcknowledgementSlot' },
          sorter: true
        },
        {
          title: '处理方式',
          align: 'center',
          dataIndex: 'disposal_dictText',
          sorter: true
        },
        {
          title: '是否恢复',
          align: 'center',
          dataIndex: 'isRecovery_dictText',
          scopedSlots: { customRender: 'recoverySlot' },
          sorter: true
        },
        {
          title: '告警分类',
          align: 'center',
          dataIndex: 'alertType_dictText',
          sorter: true
        },
        {
          title: '附件',
          align: 'center',
          dataIndex: 'attachment',
          sorter: true
        },
        {
          title: '预警等级',
          align: 'center',
          dataIndex: 'alertLevel_dictText',
          scopedSlots: { customRender: 'levelSlot' },
          sorter: true
        },
        {
          title: '测点点号',
          align: 'center',
          dataIndex: 'pointCode',
          sorter: true
        }
      ],
      columns1: [
        {
          title: '测点名称',
          align: 'center',
          dataIndex: 'pointName'
        },
        {
          title: '计量单位',
          align: 'center',
          dataIndex: 'dataUnit'
        },
        {
          title: '数据来源',
          align: 'center',
          dataIndex: 'dataSource'
        },
        {
          title: '量程上限',
          align: 'center',
          dataIndex: 'toprange'
        },
        {
          title: '量程下限',
          align: 'center',
          dataIndex: 'botrange'
        }
      ],
      dataSource1: [],
      /* 分页参数 */
      ipagination1: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* table加载状态 */
      loading1: false,
      colorList: {}
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  async created() {
    await this.loadColor()
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
    this.$nextTick(() => {
      //查询告警
      this.loadData(1)
      //查询某个时刻的断面
      this.loadData1(1)
    })
  },
  methods: {
    edit(record) {
      this.model = record
      this.visible = true
    },
    async loadColor() {
      const colorData = await getAction('/custom/category/childListByPCode', {
        pCode: 'A08A01'
      })

      if (colorData.success) {
        const color = colorData.result
          .map(({ name, cusProp1 }) => ({
            name,
            cusProp1
          }))
          .reduce((pre, cur) => {
            pre[cur.name] = cur.cusProp1
            return pre
          }, {})

        this.colorList = color
      }
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = Object.assign(this.getQueryParams(), {
        startTime: this.model.recordStartTime,
        endTime: this.model.recordTime
      }) // 查询条件
      this.loading = true
      getAction(this.url.list, params)
        .then(res => {
          if (res.success) {
            // update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
            // update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getQueryParams1() {
      // 获取查询条件
      var param = {}
      param.pageNo = this.ipagination1.current
      param.pageSize = this.ipagination1.pageSize
      return param
    },
    handleTableChange1(pagination) {
      this.ipagination1 = pagination
      this.loadData1()
    },
    loadData1(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination1.current = 1
      }
      var params = Object.assign(this.getQueryParams1(), {
        startTime: this.model.recordTime,
        isProImportant: 1
      }) // 查询条件
      this.loading1 = true
      getAction(this.url.getIotModelPoints, Object.assign(params, { pageSize: 999999 }))
        .then(res => {
          if (res.success) {
            // update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
            this.dataSource1 = res.result.records || res.result
            if (res.result.total) {
              this.ipagination1.total = res.result.total
            } else {
              this.ipagination1.total = 0
            }
            // update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading1 = false
        })
    },
    handleToPointsUrl(val) {
      this.$emit('close')
      this.$router.push({ path: '/monitor/dataLine', query: '' })
    },
    getDescItemStyle(item, pointCode) {
      let style = {
        'text-align': 'right'
      }
      if (pointCode.toLocaleUpperCase().includes('_ALARM')) {
        style['color'] = '#fff'
        style['background-color'] = item.value == 1 ? this.colorList.stop : this.colorList.run
      } else if (pointCode.toLocaleUpperCase().endsWith('RUN')) {
        style['color'] = '#fff'
        style['background-color'] = item.value == 1 ? this.colorList.run : this.colorList.stop
      } else if (pointCode.toLocaleUpperCase().endsWith('STATE')) {
        style['color'] = '#fff'
        style['background-color'] = item.value == 1 ? this.colorList.run : this.colorList.stop
      }
      return style
    }
  }
}
</script>

<style lang="less" scoped>
.card-head-title {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 24px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  background: transparent;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 2px 2px 0 0;
  zoom: 1;
}
</style>
